import { Form } from 'dash-ui';
import { AccountStatusesEnum } from 'dash-common';
import { useTranslation } from 'react-i18next';

const AccountStatusSelect = ({ status }: { status?: string }) => {
  const { t } = useTranslation('common');

  const options = Object.keys(AccountStatusesEnum).map((key: string) => ({
    label: t(`common:accountStatuses.${key}`),
    value: key,
  }));

  return (
    <Form.Group w="100%" mt={3}>
      <Form.Label required>{t('common:labels.status')}</Form.Label>
      <Form.Select
        options={options}
        value={status}
        placeholder={t('common:labels.status')}
        w="100%"
        disabled={true}
      />
    </Form.Group>
  );
};

export default AccountStatusSelect;
